class LocalizationDataService {
    getLocale() {
        const app = document.getElementById('mobile-navigation');
        let locale = "en";
        let curLocale = "";
        const locales = ["fi","sv","en"];

        if (app) {
            if (app.dataset?.lang) curLocale = app.dataset.lang
            if (locales.includes(curLocale)) locale = curLocale
        }
        return locale
    }

    getText(text) {
        const translations = {
            "fi": {
                "section-sub-menu": "-osion alavalikko",
                "back-main-nav": "Takaisin päävalikkoon"
            },
            "sv": {
                "section-sub-menu": "undermeny",
                "back-main-nav": "Tillbaka till huvudmenyn"
            },
            "en": {
                "section-sub-menu": "submenu",
                "back-main-nav": "Tillbaka till huvudmenyn"
            }
        }

        return translations[this.getLocale()][text];
    }
}

export default new LocalizationDataService();